<template>
  <a-card :bordered="false">
    <a-result status="403" title="暂无可访问页面" sub-title="请联系管理员分配菜单权限" />
  </a-card>
</template>
